import BillerView from "compid/shared/views/BillerView";
import BillerPaymentView from "compid/shared/views/BillerView/components/views/BillerPaymentView";

import { useModel } from "@bcm-dev/bcms-vite";
import { Payment } from "model";

export default function PaidBillerView({ biller, bill }) {
    const model = useModel();
    // Determine if there are any recent activity for biller
    const recentActivity = model.payments.map(payment => Payment.init(payment), [])
        .filter(payment => payment.to.id === bill.biller.id, [])
        .sort((a, b) => {
            if(a.date.isBefore(b.date)) { return 1; }
            else if(b.date.isBefore(a.date)) { return -1; }
            else { return 0; }
        });
    const scheduledPayment = recentActivity.find(payment => payment.status === "scheduled");
    const processedPayment = recentActivity.find(payment => payment.status === "processed");

    let date = bill.formatDate
    let status = bill.status;

    if(recentActivity.length > 0) {
        date = scheduledPayment instanceof Payment ? scheduledPayment.formatDate : processedPayment.formatDate;
        status = scheduledPayment instanceof Payment ? scheduledPayment.status : processedPayment.status;
    }

    return (
        <BillerView  
            biller={ biller }
            paymentInfo={ 
                <BillerPaymentView 
                    amount={ bill.amount } 
                    date={ date } 
                    status={ status } 
                    description="" />
            } 
            />
    );
}